import React from "react";
import { Bar } from "react-chartjs-2";

export const BarChart = ({ chartData }) => {
  const attempts = chartData._attempts || [];

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "rgba(20, 20, 40, 0.95)",
        titleColor: "#fff",
        bodyColor: "rgba(255,255,255,0.85)",
        borderColor: "rgba(255,255,255,0.15)",
        borderWidth: 1,
        cornerRadius: 8,
        padding: 12,
        titleFont: { size: 13, weight: "bold" },
        bodyFont: { size: 12 },
        displayColors: false,
        callbacks: {
          title: (items) => items[0]?.label || "",
          label: (item) => {
            const idx = item.dataIndex;
            const acc = item.raw;
            const info = attempts[idx];
            if (!info || info.total === 0) return "Not attempted yet";
            return [
              `Accuracy: ${acc}%`,
              `Correct: ${info.correct} / ${info.total} attempts`,
            ];
          },
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: "rgba(0,0,0,0.6)",
          font: { size: 11, weight: "500" },
          maxRotation: 45,
          minRotation: 0,
        },
      },
      y: {
        min: 0,
        max: 100,
        grid: { color: "rgba(0,0,0,0.07)", drawBorder: false },
        ticks: {
          color: "rgba(0,0,0,0.45)",
          font: { size: 11 },
          stepSize: 20,
          callback: (value) => `${value}%`,
        },
      },
    },
    animation: { duration: 500, easing: "easeOutQuart" },
    layout: {
      padding: { top: 4, right: 8, bottom: 0, left: 0 },
    },
  };

  const data = {
    ...chartData,
    datasets: chartData.datasets.map((ds) => ({
      ...ds,
      barPercentage: 0.7,
      categoryPercentage: 0.8,
    })),
  };

  return (
    <div className="chart-container">
      <Bar data={data} options={options} />
    </div>
  );
};
